"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFormats = exports.checkConsistency = void 0;
const utils_1 = require("./utils");
const loc_1 = require("./loc");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const checkSize = (state, id) => {
    const node = state.map[id];
    let size = node.deleted ? 0 : utils_1.contentChars(node.content);
    node.children.forEach(child => {
        checkSize(state, child);
        size += state.map[child].size;
    });
    if (size !== node.size) {
        console.log(size, node.size, node);
        throw new Error(`Wrong cached size ${node.size} - should be ${size}; for ${id}`);
    }
};
exports.checkConsistency = (state) => {
    state.roots.forEach(id => checkSize(state, id));
    exports.checkFormats(state);
};
exports.checkFormats = (state) => {
    const format = {};
    loc_1.walk(state, node => {
        if (node.content.type === 'open') {
            const content = node.content;
            if (!format[content.key]) {
                format[content.key] = [utils_1.toKey(node.id)];
            }
            else {
                const idx = loc_1.fmtIdx(format[content.key].map(id => state.map[id].content), content);
                // insert into sorted order.
                format[content.key].splice(idx, 0, utils_1.toKey(node.id));
            }
        }
        else if (node.content.type === 'close') {
            const content = node.content;
            const f = format[content.key];
            if (!f) {
                console.log('Found a "close" marker, but no open marker.', content.key, format, content);
                return;
            }
            const idx = f.findIndex(item => state.map[item].content.type !== 'text' &&
                state.map[item].content.stamp === content.stamp);
            if (idx !== -1) {
                f.splice(idx, 1);
            }
            if (!f.length) {
                delete format[content.key];
            }
        }
        if (!fast_deep_equal_1.default(format, node.formats)) {
            throw new Error(`Formats mismatch for ${utils_1.toKey(node.id)}: expected: ${JSON.stringify(format)}; actual: ${JSON.stringify(node.formats)}`);
        }
    });
};
